import dayjs from 'dayjs';

export const formatDate = (date: Date) => dayjs(date).format('MMM DD, YYYY');

export const getXsdDateStringFromDate = (date: Date) => {
  // XSD date format is YYYY-MM-DDThh:mm:ss[Z|(+|-)hh:mm], which is also valid ISO format
  return dayjs(date).format(`YYYY-MM-DD`);
};

export const getXsdDateTimeStringFromDate = (date: Date) => {
  // XSD date format is YYYY-MM-DDThh:mm:ss[Z|(+|-)hh:mm], which is also valid ISO format
  return dayjs(date).format(`YYYY-MM-DD[T]HH:mm:ss`);
};

export const getXsdTimeStringFromDate = (date: Date) => {
  // XSD time format is hh:mm:ss[Z|(+|-)hh:mm]
  return dayjs(date).format('HH:mm:ss');
};

// this is required since blueprint expects a date for its timepicker component
// (it uses an arbitrary date as well!)
export const getDateFromXsdTimeString = (timeString: string) => {
  const isoString = new Date().toISOString();

  const dateString = isoString.split('T')[0];
  const date = new Date(`${dateString}T${timeString}`);
  const updatedDate = dayjs(date).toDate();
  return updatedDate;
};
